import { Button, Checkbox } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IMAGE_BASE_URL } from '../../common/Constants';
import CommonPopup from '../../components/popup/CommonPopup';
import BonusCard from '../SingleProduct/BonusCard';

const SelAgentCard = (props) => {
  const {
    selectedBonus,
    setSelectedBonus,
    setselectedLoans,
    selectedLoans,
    HandleBonusChange,
  } = props;
  const selectedBonusDetails = {};
  const [isOpenBonus, setisOpenBonus] = useState({
    open: false,
    agentBonus: {},
  });
  const [temp, setTemp] = useState(
    Object.keys(selectedBonus)?.length > 0 ? selectedBonus : {}
  );
  const product = props.product;

  console.log("=====image",product)
  const selectedAhent = props?.selectedAgent;
  const { setselAgentPop, setSelectedAgent } = props.context;
  const Interest = product.activeinterest;
  console.log('Interest', product);
  let startDate = Interest?.startDate
    ? dayjs(Interest?.startDate).format('DD MMM YYYY').toUpperCase()
    : null;
  let endDate = Interest?.endDate
    ? dayjs(Interest?.endDate).format('DD MMM YYYY').toUpperCase()
    : null;
  const handleAgentBonus = (e) => {
    e.preventDefault();
    const agentData = {
      name: product.name,
      icon: product.icon,
      startDate,
      endDate,
      interest: Interest?.interest,
    };
    if (product?.bonuses && product?.bonuses.length > 0) {
      props.allAgentBonus(agentData, product?.bonuses);
    }
  };

  useEffect(() => {
    if (Object.keys(selectedBonus)?.length > 0) {
      setTemp(selectedBonus);
    }
  }, [selectedBonus, isOpenBonus]);
  const handleSelAgent = () => {
    setselAgentPop(true);
    const editedProduct = product.interestData.find((item) => item.hasPremium);
    if (editedProduct) {
      const activeAgentProduct = {
        ...product,
        defaultAgent: editedProduct,
      };
      setSelectedAgent(activeAgentProduct);
    } else {
      setSelectedAgent(product);
    }
  };
  useEffect(() => {
    console.log(product);
  }, []);

  const handleselBonus = () => {
    setisOpenBonus({ open: false, agentBonus: {} });
    setTemp({});
  };
  const HandleBonus = (checkState, productId, bonusId) => {
    console.log('checkState', checkState);
    if (Object.keys(temp)?.length > 0) {
      if (!checkState) {
        setTemp((current) => {
          const copy = { ...current };
          delete copy[productId];
          return copy;
        });
      } else {
        setTemp({ ...selectedBonus, [productId]: bonusId });
      }
    } else {
      setTemp({ ...selectedBonus, [productId]: bonusId });
    }
  };

  const handleCancel = (productId) => {
    setTemp({ ...delete temp[productId] });
    handleselBonus();
  };
  const handleSave = () => {
    setSelectedBonus(temp);
    console.log('FINNABONUSSELECTIION', temp, product, selectedLoans);
    const Array = selectedLoans?.map((it) => {
      if (it?.product === product?.id) {
        return {
          ...it,
          dealerBonus: temp[product?.id],
        };
      } else {
        return {
          ...it,
        };
      }
    });
    setselectedLoans(Array);
    handleselBonus();
    setTimeout(() => {
      HandleBonusChange(Array);
    }, 1000);
  };

  const GetSelectedBonusDetails = (agentBonus, bonusID) => {
    console.log('GET PROps', agentBonus, bonusID);
    if (agentBonus !== undefined && bonusID !== undefined) {
      const temp = agentBonus
        ?.filter((it) => it?.bonusinfo?.id === bonusID)
        .flat();
      return temp[0]?.bonusinfo?.name !== undefined
        ? temp[0]?.bonusinfo?.name
        : '';
      console.log('TEMP', temp[0]?.bonusinfo?.name);
    }
  };

  return (
    <>
      <div className='rounded-[16px] bg-white  p-[16px_20px] w-full cus_shadow2 relative max-[600px]:px-[5px]'>
        <div className='flex justify-between max-[600px]:flex-wrap'>
          <div className='flex-[1]'>
            <div className='card_head relative flex items-center mb-[10px]'>
              <div className='absolute top-[-33px] left-0 bg-white h-[58px] w-[58px] rounded-[8px]'>
                <img
                  src={`${IMAGE_BASE_URL}${product.icon}`}
                  alt='Bank Logo'
                  className='rounded-[8px]'
                  width='58'
                  height='58'
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
              </div>
              <span className='pl-[70px] font-[700]'>{product.name}</span>
              <span className='ml-[15px]'>
                {product.hasPremium ? (
                  <span className='inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500] mr-[10px]'>
                    <img
                      src='/images/prem_icon.svg'
                      className='w-[16px]'
                      alt='star'
                    />{' '}
                    <span className='relative top-[1px]'>Premium</span>
                  </span>
                ) : null}
                {product.featured ? (
                  <span className='inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500]'>
                    <img
                      src='/images/star.svg'
                      className='w-[16px]'
                      alt='star'
                    />{' '}
                    <span className='relative top-[1px]'>Featured</span>
                  </span>
                ) : null}
              </span>
            </div>
            <div className='flex flex-wrap justify-between mt-[20px] gap-[15px]'>
              <div>
                <p className='text-[12px] mb-[8px] flex items-center'>
                  <img
                    src='/images/fi_dollar.svg'
                    alt='calendar'
                    className='mr-[5px]'
                  />
                  Min. Loan:{' '}
                  <strong className='ml-[5px] font-[600]'>
                    {Interest?.minimum_loan_amount > 0
                      ? '$' + parseInt(Interest?.minimum_loan_amount)
                      : 'No min. loan required'}{' '}
                    {Interest?.admin_fee_status === '1' &&
                      `else + admin fee $${parseInt(Interest?.admin_fee)}`}
                  </strong>
                </p>
                <p className='text-[12px] mb-[8px] flex items-center'>
                  <img
                    src='/images/fi_calendar.svg'
                    alt='calendar'
                    className='mr-[5px]'
                  />
                  Available from:{' '}
                  <strong className='ml-[5px] font-[600]'>
                    {startDate}
                    <span className='mx-[6px]'>to</span>
                    {endDate ? endDate : 'Further Notice'}
                  </strong>
                </p>
                <div className='flex flex-wrap items-center justify-between gap-[5px_25px]'>
                  <p className='text-[12px] mb-[0] flex items-center'>
                    <img
                      src='/images/fi_clock.svg'
                      alt='calendar'
                      className='mr-[5px]'
                    />
                    Approval time:{' '}
                    <strong className='ml-[5px] font-[600]'>
                      {product?.approvaltimeinfo?.name}
                    </strong>
                  </p>
                  <p className='text-[12px] mb-[0] flex items-center'>
                    <img
                      src='/images/fi_zap.svg'
                      alt='calendar'
                      className='mr-[5px]'
                    />
                    Loan to Value:{' '}
                    <strong className='ml-[5px] font-[600]'>
                      {product?.ltvinfo?.name}
                    </strong>
                  </p>
                </div>
              </div>
              <div className='relative bottom-[7px] min-w-[290px] max-w-full'>
                <div className='text-[26px] font-[800]'>
                  {Interest?.interest}%
                </div>

                {/* <div
                  className='text-[13px] text-[#0F59F9]'
                  onClick={handleAgentBonus}
                >
                  {product.activeAgent?.agentcommisioninfo?.agentbonuses
                    ?.length !== undefined
                    ? `Bonus (${product.activeAgent?.agentcommisioninfo?.agentbonuses?.length})`
                    : product.defaultAgent?.agentcommisioninfo?.agentbonuses
                        ?.length > 0
                    ? `Bonus (${product.defaultAgent?.agentcommisioninfo?.agentbonuses?.length})`
                    : 'Bonus (0)'}
                  {}
                  Bonus (
                  {Interest?.allagentbonuses
                    ? Interest?.allagentbonuses?.length
                    : 0}
                  )
                </div> */}
              </div>
              <div className='relative min-w-[250px] max-w-full min-[1332px]:-mt-10'>
                {!!product.haveAgent ? (
                  <div className='text-[12px]'>
                    <label className='block text-[#787486] font-[400] mb-[8px]'>
                      Selected Agent
                    </label>
                    <div className='flex gap-[10px] items-center'>
                      <div className='h-[38px] w-[38px] rounded-[10px] border border-[#E9E9E9]'>
                        <img
                          src={`${IMAGE_BASE_URL}/${product.activeAgent.agentinfo.icon}`}
                          alt='logo'
                          className='h-full w-full object-contain'
                        />
                      </div>
                      <div className='text-[#0D062D] font-[700] text-[17px]'>
                        {product.activeAgent.agentinfo.name}
                      </div>
                    </div>
                    {/* <div className='select-bonus-block'>
                      <label>Dealer Bonus</label>
                      {product.activeAgent?.agentcommisioninfo?.agentbonuses
                        ?.length > 0 ? (
                        <span
                          onClick={() => {
                            setisOpenBonus({
                              open: true,
                              agentBonus: product.activeAgent,
                            });
                          }}
                        >
                          {product.activeAgent?.agentcommisioninfo?.agentbonuses
                            ?.map((it) => it?.bonusinfo?.id)
                            ?.includes(selectedBonus[product?.id])
                            ? GetSelectedBonusDetails(
                                product.activeAgent?.agentcommisioninfo
                                  ?.agentbonuses,
                                selectedBonus[product?.id]
                              ) !== ''
                              ? `( ${GetSelectedBonusDetails(
                                  product.activeAgent?.agentcommisioninfo
                                    ?.agentbonuses,
                                  selectedBonus[product?.id]
                                )} ) - Change`
                              : 'Change Bonus'
                            : `Select Bonus`}
                        </span>
                      ) : (
                        <span> No Bonus Data Found for Agent</span>
                      )}
                    </div> */}
                  </div>
                ) : !!product.defaultAgent ? (
                  <>
                    <div className='text-[12px]'>
                      <label className='block text-[#787486] font-[400] mb-[8px]'>
                        Selected Agent
                      </label>
                      <div className='flex gap-[10px] items-center'>
                        <div className='h-[38px] w-[38px] rounded-[10px] border border-[#E9E9E9]'>
                          <img
                            src={`${IMAGE_BASE_URL}/${product.defaultAgent.agentinfo.icon}`}
                            alt='logo'
                            className='h-full w-full object-contain'
                          />
                        </div>
                        <div className='text-[#0D062D] font-[700] text-[17px]'>
                          {product.defaultAgent.agentinfo.name}
                        </div>
                      </div>
                    </div>
                    {/* <div className='select-bonus-block'>
                      <label>Dealer Bonus</label>
                      {product.defaultAgent?.agentcommisioninfo?.agentbonuses
                        ?.length > 0 ? (
                        <span
                          onClick={() => {
                            setisOpenBonus({
                              open: true,
                              agentBonus: product.defaultAgent,
                            });
                          }}
                        >
                          {product.defaultAgent?.agentcommisioninfo?.agentbonuses
                            ?.map((it) => it?.bonusinfo?.id)
                            ?.includes(selectedBonus[product?.id])
                            ? GetSelectedBonusDetails(
                                product.defaultAgent?.agentcommisioninfo
                                  ?.agentbonuses,
                                selectedBonus[product?.id]
                              ) !== ''
                              ? `( ${GetSelectedBonusDetails(
                                  product.defaultAgent?.agentcommisioninfo
                                    ?.agentbonuses,
                                  selectedBonus[product?.id]
                                )} ) - Change`
                              : 'Change Bonus'
                            : `Select Bonus`}
                        </span>
                      ) : (
                        <span> No Bonus Data Found for Agent</span>
                      )}
                    </div> */}
                  </>
                ) : (
                  <div className='text-[12px] text-[#FD4954] font-[500]'>
                    Select Agent*
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='text-center pl-[80px] max-[600px]:pl-0 max-[600px]:w-full max-[600px]:text-start max-[600px]:mt-[30px]'>
            <p className='text-[#787486] mb-[3px] text-[12px]'>
              Monthly Installment
            </p>
            <p className='text-[#0D062D] text-[20px] mb-[10px] font-[800]'>
              ${product?.monthly_installment}
            </p>
            <Button
              type='primary'
              size='large'
              className={`loan_com_btn ${
                !!product.haveAgent || !!product.defaultAgent ? 'active' : ''
              }`}
              onClick={handleSelAgent}
            >
              {!!product.haveAgent || !!product.defaultAgent
                ? 'Change Agent'
                : 'Select Agent'}
            </Button>
          </div>
        </div>
      </div>
      <CommonPopup
        size='xlg'
        isOpen={isOpenBonus.open}
        onClose={handleselBonus}
        title={`Select Bonus ( ${
          isOpenBonus?.agentBonus?.agentcommisioninfo?.agentbonuses?.length !==
          undefined
            ? isOpenBonus?.agentBonus?.agentcommisioninfo?.agentbonuses?.length
            : 0
        } )`}
      >
        {console.log('PORP UP ISOPEN', isOpenBonus?.agentBonus)}
        <div className='flex items-center flex-wrap gap-[15px_10px] justify-between pb-[20px] sticky top-0 bg-white left-0 z-[10]'>
          <div className='flex items-center'>
            <div className='mr-[12px]'>
              <img
                src={`${IMAGE_BASE_URL}${product.icon}`}
                alt='bank logo'
                className='w-[47px] h-[47px] object-contain bg-white rounded-[4px]'
              />
            </div>
            <div>
              <h3 className='text-[#0D062D] font-[700]'>{product?.name}</h3>
              <p className='text-[12px] text-[#787486] flex items-center'>
                <img
                  src='/images/fi_calendar.svg'
                  alt='calendar'
                  className='mr-[7px]'
                />
                Available from:{' '}
                <strong className='ml-[5px] font-[600] text-[#0F0F0F]'>
                  {startDate}
                  <span className='mx-[4px]'>to</span>{' '}
                  {endDate ? endDate : 'Further Notice'}
                </strong>
              </p>
            </div>
          </div>
          <div>
            <span className='inline-block text-[#0D062D] ml-[5px] font-[800] text-[30px]'>
              {Interest?.interest}%
            </span>
          </div>
        </div>
        {isOpenBonus?.agentBonus?.agentcommisioninfo?.agentbonuses?.length >
          0 && (
          <div className='border border-[#E0E0E0] mb-[20px] rounded-[8px] px-[15px] py-[15px] bg-white relative grid gap-[15px]'>
            <div className='flex items-center sticky top-[67px] bg-white left-0 z-[9]'>
              <span>
                <img
                  src={`${IMAGE_BASE_URL}${isOpenBonus?.agentBonus?.agentinfo?.icon}`}
                  alt='agent icon'
                  className='w-[28px] h-[28px] object-contain bg-white rounded-[4px]'
                />
              </span>
              <span className='text-[#0D062D] text-[14px] font-[700] ml-[8px]'>
                {isOpenBonus?.agentBonus?.agentinfo?.name}
              </span>
            </div>
            {isOpenBonus?.agentBonus?.agentcommisioninfo?.agentbonuses?.length >
            0 ? (
              isOpenBonus?.agentBonus?.agentcommisioninfo?.agentbonuses.map(
                (bonus, idx) => {
                  console.log('BONUS', temp, bonus);
                  return (
                    <label
                      htmlFor={`selBns${idx}`}
                      className={`flex items-center gap-[10px] cursor-pointer "diab_lbl"
      }`}
                      key={idx}
                    >
                      <Checkbox
                        id={`selBns${idx}`}
                        onClick={(e) => {
                          HandleBonus(
                            e.target.checked,
                            product?.id,
                            bonus?.bonusinfo?.id
                          );
                        }}
                        checked={temp[product?.id] === bonus?.bonusinfo?.id}
                      />
                      <BonusCard key={idx} cardData={bonus?.bonusinfo} />
                    </label>
                  );
                }
              )
            ) : (
              <div className='text-[13px] mt-[10px] mb-[15px] font-[500]'>
                No Bonus Selected
              </div>
            )}
          </div>
        )}
        <div className='mt-[50px]'>
          <Button
            className='ag_cancel_btn'
            onClick={() => handleCancel(product?.id)}
          >
            Cancel
          </Button>
          <Button
            type='primary'
            className='ag_confirm_btn'
            onClick={() => handleSave()}
          >
            Confirm
          </Button>
        </div>
      </CommonPopup>
    </>
  );
};

export default SelAgentCard;
